<template>
  <simple-activity :show-header="false">
    <div class="app-container" style="display: flex; flex-direction: column; align-items: center;">
      <div class="row justify-content-center justify-content-lg-start w-100 mt-4 mr-0 ml-0">
        <VideoGuideCard
            v-for="(guide, index) in videoGuides"
            :key="index"
            :imageSrc="guide.imageSrc"
            :imageAlt="guide.imageAlt"
            :imageLink="guide.imageLink"
            :videoLink="guide.videoLink"
        />
      </div>
    </div>
  </simple-activity>
</template>

<script>
import Activity from "@/activity/Activity";
import SimpleActivity from "@/activity/templates/layouts/SimpleActivity";
import VideoGuideCard from "@/components/dashboard/VideoGuideCard.vue";

export default {
  name: "GuidesActivity",
  components: { SimpleActivity, VideoGuideCard },

  props: {
    title: {
      type: String,
      required: true
    },
    videoGuides: {
      type: Array,
      required: true
    }
  },

  methods: {
    ...Activity.methods,

    getTitle() {
      return this.title;
    }
  }
};
</script>

<style scoped>
.row {
  gap: 10px;
}
</style>
